import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import KopiContainer from "../../Common/Ileggelser/Detalj/KopiContainer";
import PrintOut from "../../Common/PrintOut";
import MakulerModalContainer from "../../Common/MakulerModalContainer";
import ForsinketMakuleringContainer from "./ButtonPanelButtons/ForsinketMakuleringContainer";
import OpphevMakuleringContainer from "./ButtonPanelButtons/OpphevMakuleringContainer";
import OpphevForsinketMakuleringContainer from "./ButtonPanelButtons/OpphevForsinketMakuerlingContainer";
import SendTilIneContainer from "./ButtonPanelButtons/SendTilIneContainer";
import SendTilGodkjenningContainer from "./ButtonPanelButtons/SendTilGodkjenningContainer";
import NyEttersendelseContainer from "./ButtonPanelButtons/NyEttersendelseContainer";
import EndreIleggelseContainer from "./ButtonPanelButtons/EndreIleggelseContainer";
import OpenMakulerModalStandardButton from "../../Common/IleggelseClient/OpenMakulerModalStandardButton";

import { postIleggelserMakulering as postIleggelserMakuleringAction } from "../../../actions/ileggelseMakuleringerActions";
import {
  getIleggelse as getIleggelseAction,
  getIleggelseHistorikk as getIleggelseHistorikkAction,
} from "../../../actions/ileggelserActions";
import { getIleggelseMakuleringer as getIleggelseMakuleringerAction } from "../../../actions/ileggelseMakuleringerActions";

import { getMostRecentObjectComparedOnParameter } from "../../../utils/date";
import { authorized } from "../../../utils/authorizationUtils";
import { bypatruljen } from "../../../constants/roles";

export default function ButtonsContainer({ ileggelseId }) {
  const dispatch = useDispatch();
  const ileggelse = useSelector((state) => state.ileggelse);
  const ileggelseEttersendelser = useSelector(
    (state) => state.ileggelseEttersendelser,
  );

  const authorizedSaksbehandler = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
  ]);

  const latestEttersendelse = useMemo(
    () =>
      ileggelseEttersendelser && ileggelseEttersendelser.length > 0
        ? getMostRecentObjectComparedOnParameter(
            ileggelseEttersendelser,
            "ettersendelseDato",
          )
        : null,
    [ileggelseEttersendelser],
  );

  const reloadHistorikk = async () => {
    await dispatch(getIleggelseHistorikkAction(ileggelseId));
  };

  const postIleggelserMakulering = (id, kommentar) =>
    dispatch(postIleggelserMakuleringAction(id, kommentar))
      .then(() => {
        dispatch(getIleggelseAction(id));
        dispatch(getIleggelseMakuleringerAction(id));
        reloadHistorikk();
      })
      .catch(() => Promise.reject(true));

  const showMakuler = () =>
    !ileggelse.isMakulert &&
    !ileggelse.isBetalingsfristUtlopt &&
    ileggelse.forsinketMakuleringStatus &&
    !ileggelse.forsinketMakuleringStatus.createPossible &&
    !ileggelse.forsinketMakuleringStatus.deletePossible &&
    !ileggelse.isSendtKemner;

  return (
    <section
      className="detalj-ileggelse-section-margin no-print"
      style={{ height: 40 }}
    >
      {ileggelse && ileggelse.id === ileggelseId && (
        <React.Fragment>
          <div className="pull-left">
            <KopiContainer />
            <PrintOut />
          </div>
          <div className="pull-right">
            {authorizedSaksbehandler && showMakuler() && (
              <MakulerModalContainer
                id={ileggelse.id}
                titleType="ileggelse"
                ileggelsesnummer={ileggelse.ileggelsesnummer}
                openMakulerModal={OpenMakulerModalStandardButton}
                postMakulering={postIleggelserMakulering}
              />
            )}
            {authorizedSaksbehandler && (
              <ForsinketMakuleringContainer
                ileggelse={ileggelse}
                reloadHistorikk={reloadHistorikk}
              />
            )}
            {authorizedSaksbehandler && (
              <OpphevMakuleringContainer reloadHistorikk={reloadHistorikk} />
            )}
            {authorizedSaksbehandler && (
              <OpphevForsinketMakuleringContainer
                ileggelse={ileggelse}
                reloadHistorikk={reloadHistorikk}
              />
            )}
            {authorizedSaksbehandler && <SendTilIneContainer />}
            {authorizedSaksbehandler && (
              <SendTilGodkjenningContainer
                latestEttersendelseId={
                  latestEttersendelse && latestEttersendelse.id
                }
                reloadHistorikk={reloadHistorikk}
              />
            )}
            {authorizedSaksbehandler && (
              <NyEttersendelseContainer reloadHistorikk={reloadHistorikk} />
            )}
            {authorizedSaksbehandler && <EndreIleggelseContainer />}
          </div>
        </React.Fragment>
      )}
    </section>
  );
}
